import { PHONE_TEL_URL, WHATSAPP_URL } from "@/constants/contact";

export default function WhatsAppFloat() {
  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col gap-3 items-center">
      <a
        href={PHONE_TEL_URL}
        className="w-14 h-14 bg-teal-600 hover:bg-teal-500 rounded-2xl shadow-[0_0_30px_-5px_rgba(20,184,166,0.6)] flex items-center justify-center transition-all duration-300 hover:scale-110 border border-teal-400/30"
        aria-label="اتصل بنا"
      >
        <i className="ri-phone-line text-white text-2xl" />
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-green-500 hover:bg-green-400 rounded-2xl shadow-[0_0_30px_-5px_rgba(34,197,94,0.6)] flex items-center justify-center transition-all duration-300 hover:scale-110 animate-float border border-green-400/30"
        aria-label="تواصل عبر واتساب"
      >
        <i className="ri-whatsapp-line text-white text-2xl" />
      </a>
    </div>
  );
}
